<template>
    <div class="listmain ">
         <h1 class="firTitle">标准响应</h1>
              <p>用户技能网关通过 HTTP协议响应JSON数据，OrionOS网关应在5秒内响应结果，如未能及时响应，OrionOS将抛弃该请求。
              </p>
              <h5 class="thirdTitle">请求头信息：</h5>
              <p>HTTP/1.1 200 OK
                <br>Content-Type:application/json:charset=UTF-8
                <br>Content-Length:
              </p>
               <h5 class="thirdTitle">请求内容格式规范及参数说明</h5>
               <p>Response Body Syntax
              </p>
              <h5 class="codeTitle">example</h5>
               <highlight-code lang="javascript">
                   <span>
{
    "version": "0.1.1", //Type:String,版本号，请求字段中的version
    "response": {//Type:JSONObject
        "outSpeech": {//Type:JSONObject
            "type": "text"//Type:String,输出的语音类型,取值类型：text、ssml
            "text": "这是要转换成语音的文字"//Type:String,普通文本描述的语音文字
            "textBGM":"http://*.mp3"//Type:String,普通文本背景音
            "ssml": "SSML协议"//Type:String,SSML协议描述的语音文字
        },
        "display":{//Type:JSONObject，该部分是上屏数据，需要技能的同学进行一次补全
            "type":"DISPLAY.[XXXXX]"//Type:String,显示数据的数据类型，取值类型：DISPLAY.[XXXXXX] , 开发者需要遵循该定义规则以DISPLAY.开头[XXXXX]为自定义内容
            "data":{//Type:JSONObject
                //JSONObject 该字段需要与上面DISPLAY进行统一定义，和业务有关。
            }
        },
        "card": {//Type:JSONObject，该部分为信息流的数据，之前定义的标准化样式应该现在也不标准了，如果还是标准的应该根据type类型，去描述一下每一种type应该使用那些字段进行描述。
            "text":"", //Type:String,输出的文本信息，如果为空该信息不限制
            "popup":"",//Type:String,手机APP是否允许直接弹窗，Pop(弹出)、Auto（自动：依赖于客户端逻辑，兼容之前），Forbid(禁止，客户端在任何情况下都不允许弹出)
            "ui":[//Type:JSONArray
            {//Type:JSONObject,信息流卡片的展示效果，该字段中的数据根据type类型中的数据进行变化。 如果数据不存在情况下为：null
                "type": "Simple（1）/Image（2）/ImageText（3）/ImageTextButtion（4）/Weather（C1）/WeatherAirQuality（C2）",//Type:String,类型，Simple，Audio ...
                "bg":{//Type:JSONObject,背景的描述
                    "coler":"",//Type:String,背景颜色
                    "image":"",//Type:String,背景图片
                    "virtual":true/false,//Type:Boolean,是否虚化
                },
                "attr":{//Type:JSONObject,属性
                    "title":"",//Type:String,标题
                    "subTitle":"",//Type:String,二级标题
                    "image":"",//Type:String,图片
                    "button":{//Type:JSONObject,按钮
                        "text":"",//Type:String
                        "link":"" //Type:String,button link
                    },
                    "link":"" //Type:String,panle link
                },
                "custom":{}//Type:JSONObject 针对于定制的样式使用该字段，定制的样式现在包括：Weather、WeatherAirQuality
                "skillIcon":{//Type:JSONObject,Skill角标
                    "name":"",//Type:String,角标名称
                    "image":""//Type:String,角标图片
                }
            }
            ],
            "order":{//Type:JSONObject,如果该条继续需要展示支付信息，则直接组织该字段，支付卡片统一追加到信息流卡片最下面
                "orderNo":"123123123",//Type:String,猎户支付生成的订单号
                "payClientId":"orion.pay.1508466592633", //Type:String,支付模块client_id
                "payAccessToken":"",//Type:String,支付用到的payAccessToken
                "subject":"",//Type:String,订单名称
                "subSubject":"",//Type:String,二级订单名称
                "detail":"",//Type:String,详情描述
                "pictures":[ //Type:JSONArray,最多支持5张
                    "商品图片"
                ],
                "amount":"",//Type:String,单位：元，精确到小数点后两位，字符串类型
                "paymentWay":"", //Type:String,支付方式：voiceprint：声纹支付、card：卡片支付(默认为card)
                "data":JSONObject //Type:JSONObject,与支付相关的业务数据，该字段可以存放埋点需要进行上报的数据
                "quality":int //精品内容，1：精品内容，0：不是精品内容
            },
            "linkAccount":{//Type:JSONObject,关联账号，如果用户没有登录，技能可以追加该Card信息进行LinkAccount功能的引导
                "skillId":"orion.ovs.skill.1510212090177",//Type:String,技能ID
                "platformId":"22", //Type:String,技能的资源平台ID
                "title":"",//Type:String,登录Title
                "subTitle":"",//Type:String,登录二级Title
                "icon":"",//Type:String,登录的Icon图片
                "data":JSONObject//Type:JSONObject,与账号关联相关的业务数据，该字段可以存放埋点需要进行上报的数据
            },
            "ad":{ // 广告位相关数据


            }
        },
        "skillData": {//Type:JSONObject，业务的透传字段
            //任意数据，该数据会通过语音服务透传给客户端，第三方开发技能的时候可以通过该字段往客户端进行信息的透传。
            "xiaoYaCompatible":{//Type:JSONObject,小雅兼容字段，该字段只针对于小雅进行使用，进行小雅协议的兼容。
                "code":String,//Type:String，小雅音响之前的状态码之前是放在外部协议中code中的，所以这部分做了兼容。
                "desc":String,//Type:String
                "slots":JSONObject,//Type:JSONObject
                "data":Object,//Type:Object
                "preSpeeh":String,//Type:JSONObject
                "reportQueryHistory":String   //Type:JSONObject
            },
            "dialogCompatible":{//Type:JSONObject,对话兼容字段，pyskill中的所有数据都放到该字段中，JSONObject

            }
       },
        "directives": [//Type:JSONArray
        { //Type:JSONObject,多轮协议描述
            "type": "Dialog.ElicitSlot",//Type:String
            //单槽位期望，仅一个槽位就能确定期望值，用户确定的值会放到updatedIntent中。
            "slotToElicit": "fromCity",//Type:String/JSONObject
            //多槽位期望，需要多个槽位来确定一个指，用户需求自行记录值，不会放到updatedIntent中。
            "slotToElicit":{//Type:JSONObject
                "command_param":"温度"//Type:String
                "command_value":""//Type:String,期望获得的槽位写成空字符串
            }
            "updatedIntent": {//Type:JSONObject
                "slots": {//Type:JSONObject
                    "toCity": {//Type:JSONObject
                        "name": "toCity"//Type:String
                    },
                    "travelDate": {//Type:JSONObject
                        "name": "travelDate",//Type:String
                        "value": "2017-04-21"//Type:String
                    },
                    "fromCity": {//Type:JSONObject
                        "name": "fromCity"//Type:String
                    },
                    "activity": {//Type:JSONObject
                        "name": "activity"//Type:String
                    },
                    "travelMode": {//Type:JSONObject
                        "name": "travelMode"//Type:String
                    }
                }
            }
        },
        { //Type:JSONObject,Mic 麦克风控制
            "type": "Device.Mic",//Type:String
            "value": "on"//Type:String
        },
        { //Type:JSONObject,音频播放协议描述
            "type": "AudioPlayer.Play",//Type:String
            "audioItem": {//Type:JSONObject
                "stream": { //Type:JSONObject,音频流
                    "url": "",//Type:String 播放的URL
                    "token": "", //Type:String 播放音频的唯一标示
                    "offsetInMilliSeconds": 0,//Type:int
                },
                "command": { //Type:JSONObject,前端指令，兼容百度音乐SDK，虾米音乐SDK
                    "result": {//Type:JSONObject
                        "fail": [//Type:JSONArray
                            "没有找到要点播的音乐，换一个试试吧"//Type:String
                        ],
                        "success": [//Type:JSONArray
                            "好的，刘德华,忘情水"//Type:String
                        ]
                    },
                    "function": "playbysongid",//Type:String
                    "params": [//Type:JSONArray
                        "2068460"//Type:String
                    ],
                    "class": "music"//Type:String
                }
            },
            "hasNext":true/false,//Type:Boolean,是否拥有下一首歌曲，如果有下一首歌曲，客户端在播放结束的时候会进行虚拟意图autoNext的请求。
        },
        { //Type:JSONObject,会话相关内容,通过该字段可以灵活的控制skill会话的保持与退出，会话状态
            "type": "SkillSession.Begin //Type:String,开始 SkillSession.Running //运行 SkillSession.End //结束 SkillSession.Invalid //无效"
            "attributes":{//Type:JSONObject,会话属性，会话结束后自动清空，用户会话未结束，再生命周期中会持续保持该属性，小神器
                "a":"b",//Type:String
                "c":"d"//Type:String
            },
            "context":"normal"//Type:String,上下文场景，normal，voiceprintPay 状态机上下文的重写。
        },
        {   //Type:JSONObject,广告推荐
            "type": "Ad.Recommend",//Type:String
            //广告推荐相关信息
            "adRecommendContent":{  //JSONObject
                "adTtsText":"", //String
                "ttsPlayPosition"："Tts.Begin|Tts.End"， //Tts.Begin：头部，Tts.End：尾部
                "adType":1,2,3 //广告类型  多轮TTS用户回复确认后触发 = 1，仅TTS中包含广告，后面接的内容播放与广告无关 = 2 ，普通TTS后接内容 = 3
            }
        },
        {   // 设置cookies
            "type": "Cookies.Set",
            "cookies": [
                {
                    "key": "cookie_key1",
                    "val": "cookie_val1",
                    "max_age": 0 // 可选字段, int类型,单位秒,为0时表示立即失效（删除）,为其他正整数时表示K-V存活时间,未设置此字段或为负值时，认为持久有效
                },
                {
                    "key": "cookie_key2",
                    "val": "cookie_val2",
                    "max_age": 60
                },
                ...
            ]
        }
    }
}
                   </span>
              </highlight-code>


    </div>
</template>

<script>
export default {
  name: "Ptjj"
};
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>

  h1,
  h2,
  h3,
  h4,
  h5 {
    padding: 0;
    margin: 0px;
    font-weight: normal;
  }

  ul,
  li {
    list-style: none;
  }



  .listmain {
    font-size: 14px;
    line-height: 26px;
    .firTitle {
      font-size: 20px;
      color: #1e4d79;
      margin-bottom: 30px;
    }
    .sedTitle {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 10px;
      border-bottom: 1px solid #f3f3f3;
      margin-bottom: 15px;
      margin-top: 50px;
      &.fir {
        margin-top: 0px;
      }
    }
    .thirdTitle{
      margin-top: 50px;
      font-weight: bold;
      line-height: 26px;
    }
    .codeTitle{
      font-weight: bold;
      line-height: 26px;
    }
    pre{
      margin-top: 20px;
    }
    img {
      margin: 30px 0;
    }
    table,
    table tr th,
    table tr td {
      border: 1px solid #000;
      text-align: center;
    }
    table {
      line-height: 30px;
      width: 100%;
      border-collapse: collapse;
    }
  }

  .el-submenu .el-menu-item {
    min-width: 190px;
    background: #f5f5f5;
  }

  .el-submenu {
    min-width: 190px;
    background: #f5f5f5;
  }

  img {
    margin-top: 30px;
    margin-bottom: 30px;
  }

</style>




// WEBPACK FOOTER //
// src/components/tutor/zdyjn_bzxy.vue